module.exports = __webpack_public_path__ + "img/megaphone-icon.9602c51b.svg";